import { Action, ActionReducer } from '@ngrx/store'
import * as HydrationActions from './base-hydration.actions'

function isHydrateSuccess(action: Action): action is ReturnType<typeof HydrationActions.hydrateSuccess> {
  return action.type === HydrationActions.hydrateSuccess.type
}

export const baseHydrationMetaReducer =
  (reducer: ActionReducer<any>): ActionReducer<any> =>
  (state, action) => {
    if (isHydrateSuccess(action)) {
      return action
    } else {
      return reducer(state, action)
    }
  }
